export const URL_PARAMS = {
   // Organisation
   ORGA_HASH: 'orgH',
   ORGA_NAME: 'orgN',
   // Origin (non-admin user's organisation, baked into URL)
   ORIGIN_HASH: 'oriH',
   ORIGIN_NAME: 'oriN',
   // Filter
   COUNTRIES: 'co',
   TAGS: 'tg',
   EVENTS: 'ev',
   STREAM_NAMES: 'sn',
   USAGE_SWITCH: 'uSw',
   // Timespan
   TIME_ID: 'tiId',
   TIME_INTERVAL: 'tiInt',
   TIME_START: 'tiSta',
   TIME_END: 'tiEnd',
   // Worldmap
   WORLDMAP_METRIC: 'wmMetric',
   WORLDMAP_PI_SUB: 'wmPi',
   WORLDMAP_ABR_SUB: 'wmAbr',
   WORLDMAP_CDN: 'wmCdn',
   WORLDMAP_VIEW: 'wmView',
   WORLDMAP_REGION_ZOOM: 'wmReg',
   // Troubleshooting — general
   TROUBLE_START: 'trSta',
   TROUBLE_END: 'trEnd',
   TROUBLE_INTERVAL: 'trInt',
   TROUBLE_MODE: 'trMod',
   // Troubleshooting — Ingest
   TROUBLE_INGEST_MODE: 'trIgMod',
   TROUBLE_INGEST_INPUT: 'trIgInp',
   TROUBLE_INGEST_STREAM: 'trIgStr',
   TROUBLE_INGEST_PUBLISH_START: 'trIgPuSta',
   TROUBLE_INGEST_PUBLISH_END: 'trIgPuEnd',
   TROUBLE_INGEST_PUBLISH_FINE_START: 'trIgPuFiSta',
   TROUBLE_INGEST_PUBLISH_FINE_END: 'trIgPuFiEnd',
   // Troubleshooting — Playout
   TROUBLE_PLAYOUT_INPUT: 'trPyInp',
   TROUBLE_PLAYOUT_STREAM: 'trPyStr',
   TROUBLE_PLAYOUT_ID: 'trPyId',
   TROUBLE_PLAYOUT_FINE_START: 'trPyFiSta',
   TROUBLE_PLAYOUT_FINE_END: 'trPyFiEnd',
   // Misuse
   MISUSE_START: 'misSta',
   MISUSE_END: 'misEnd',
   MISUSE_STREAMS: 'misStr',
   MISUSE_IPS: 'misIp',
   MISUSE_JTIS: 'misJti',
   MISUSE_REFERRERS: 'misRef',
   MISUSE_COUNTRIES: 'misCou',
   MISUSE_PROVIDERS: 'misPrv',
   MISUSE_USERS: 'misUsr',
   MISUSE_TAGS: 'misTag',
   MISUSE_AGG_TERM: 'misTerm',
   MISUSE_CC_STATE: 'misCc',
   // Alert
   ALERT_ID: 'alId',
   ALERT_FINE_START: 'alFiSta',
   ALERT_FINE_END: 'alFiEnd',
};

export const URL_PARAM_LABELS = {
   // Organisation
   [URL_PARAMS.ORGA_HASH]: 'Organisation Hash',
   [URL_PARAMS.ORGA_NAME]: 'Organisation Name',
   // Origin
   [URL_PARAMS.ORIGIN_HASH]: 'Origin Organisation Hash (non-admin user)',
   [URL_PARAMS.ORIGIN_NAME]: 'Origin Organisation Name (non-admin user)',
   // Filter
   [URL_PARAMS.COUNTRIES]: 'Country Filter (ISO codes)',
   [URL_PARAMS.TAGS]: 'Tag Filter',
   [URL_PARAMS.EVENTS]: 'Event Filter',
   [URL_PARAMS.STREAM_NAMES]: 'Stream Name Filter',
   [URL_PARAMS.USAGE_SWITCH]: 'Usage Switch (home / breakdown)',
   // Timespan
   [URL_PARAMS.TIME_ID]: 'Timespan Preset ID',
   [URL_PARAMS.TIME_INTERVAL]: 'Timespan Interval',
   [URL_PARAMS.TIME_START]: 'Timespan Start (UTC)',
   [URL_PARAMS.TIME_END]: 'Timespan End (UTC)',
   // Worldmap
   [URL_PARAMS.WORLDMAP_METRIC]: 'Worldmap Metric',
   [URL_PARAMS.WORLDMAP_PI_SUB]: 'Worldmap Playout/Ingest Sub-Switch',
   [URL_PARAMS.WORLDMAP_ABR_SUB]: 'Worldmap ABR Playtime Sub-Switch',
   [URL_PARAMS.WORLDMAP_CDN]: 'Worldmap CDN Option',
   [URL_PARAMS.WORLDMAP_VIEW]: 'Worldmap View Mode',
   [URL_PARAMS.WORLDMAP_REGION_ZOOM]: 'Worldmap Region Zoom',
   // Troubleshooting — general
   [URL_PARAMS.TROUBLE_START]: 'Troubleshooting Timespan Start',
   [URL_PARAMS.TROUBLE_END]: 'Troubleshooting Timespan End',
   [URL_PARAMS.TROUBLE_INTERVAL]: 'Troubleshooting Interval',
   [URL_PARAMS.TROUBLE_MODE]: 'Troubleshooting Mode',
   // Troubleshooting — Ingest
   [URL_PARAMS.TROUBLE_INGEST_MODE]: 'Troubleshooting Ingest Mode',
   [URL_PARAMS.TROUBLE_INGEST_INPUT]: 'Troubleshooting Ingest Input',
   [URL_PARAMS.TROUBLE_INGEST_STREAM]: 'Troubleshooting Ingest Stream',
   [URL_PARAMS.TROUBLE_INGEST_PUBLISH_START]: 'Troubleshooting Ingest Publish Window Start',
   [URL_PARAMS.TROUBLE_INGEST_PUBLISH_END]: 'Troubleshooting Ingest Publish Window End',
   [URL_PARAMS.TROUBLE_INGEST_PUBLISH_FINE_START]: 'Troubleshooting Ingest Publish Fine Window Start',
   [URL_PARAMS.TROUBLE_INGEST_PUBLISH_FINE_END]: 'Troubleshooting Ingest Publish Fine Window End',
   // Troubleshooting — Playout
   [URL_PARAMS.TROUBLE_PLAYOUT_INPUT]: 'Troubleshooting Playout User ID',
   [URL_PARAMS.TROUBLE_PLAYOUT_STREAM]: 'Troubleshooting Playout Stream',
   [URL_PARAMS.TROUBLE_PLAYOUT_ID]: 'Troubleshooting Playout Player ID',
   [URL_PARAMS.TROUBLE_PLAYOUT_FINE_START]: 'Troubleshooting Playout Fine Window Start',
   [URL_PARAMS.TROUBLE_PLAYOUT_FINE_END]: 'Troubleshooting Playout Fine Window End',
   // Misuse
   [URL_PARAMS.MISUSE_START]: 'Misuse Timespan Start',
   [URL_PARAMS.MISUSE_END]: 'Misuse Timespan End',
   [URL_PARAMS.MISUSE_STREAMS]: 'Misuse Stream Filter',
   [URL_PARAMS.MISUSE_IPS]: 'Misuse IP Filter',
   [URL_PARAMS.MISUSE_JTIS]: 'Misuse JTI (JWT ID) Filter',
   [URL_PARAMS.MISUSE_REFERRERS]: 'Misuse Referrer Filter',
   [URL_PARAMS.MISUSE_COUNTRIES]: 'Misuse Country Filter',
   [URL_PARAMS.MISUSE_PROVIDERS]: 'Misuse Provider Filter',
   [URL_PARAMS.MISUSE_USERS]: 'Misuse User Filter',
   [URL_PARAMS.MISUSE_TAGS]: 'Misuse Tag Filter',
   [URL_PARAMS.MISUSE_AGG_TERM]: 'Misuse Aggregation Term',
   [URL_PARAMS.MISUSE_CC_STATE]: 'Misuse CC State',
   // Alert
   [URL_PARAMS.ALERT_ID]: 'Alert ID',
   [URL_PARAMS.ALERT_FINE_START]: 'Alert Fine Window Start',
   [URL_PARAMS.ALERT_FINE_END]: 'Alert Fine Window End',
};
